import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HelperService } from './../../../services/helper.service';
import { PaymentService } from './../../../rest/api/payment.service';
import { PaymentService as PaymentLocalService } from '../../../services/payment/payment.service';
import { AuthService } from '../../../services/auth.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  packageId: any;
  isCameraPlanEnabled = false;
  plansData: any;

  subscriptionPlan: any;
  cameraPlan: any;
  taxPercentage = 0;

  loader = true;

  formData: any;
  accessToken: any;
  isSubmitted = false;
  errors = [];
  paymentErrorMessage: any;
  paymentSuccessMessage: any;
  constructor(
    private router: Router,
    public paymentLocalService: PaymentLocalService,
    public paymentService: PaymentService,
    public helperService: HelperService,
    public authService: AuthService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.isCameraPlanEnabled = this.paymentLocalService.getCameraPlan() ? true : false;
    this.paymentLocalService.planDataSubscription.subscribe(response => {
      if (response) {
        this.plansData = response;
        this.subscriptionPlan  = _.find(this.plansData, {plan_type: 'subscription' }) ? _.find(this.plansData, {plan_type: 'subscription' }) : false;
        if (this.subscriptionPlan && this.subscriptionPlan.tax) {
          this.taxPercentage = this.subscriptionPlan.tax;
        }
        this.cameraPlan  = _.find(this.plansData, {plan_type: 'camera' });
        this.loader = false;
      }
    });
  }

  ngOnInit() {
    this.formData = this.paymentLocalService.getFormData();
  }

  hashCardNumber(cardNumber) {
    if (cardNumber.length > 0) {
      return '********' + cardNumber.substr(cardNumber.length - 4);
    }
    return cardNumber;
  }

  convertDateText(date) {
    if (!date) {
      return date;
    }
    let singleMonth = '';
    let years = '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct' , 'Nov', 'Dec'];
    const explodedDate = date.split('/');
    if (explodedDate[0]) {
      const index = explodedDate[0] - 1;
      singleMonth  = months[index];
    }
    if (explodedDate[1]) {
      years = '20' + explodedDate[1];
    }
    return singleMonth + ', ' + years;
  }

  submitPayment() {
    const plans = [];
    plans.push(this.subscriptionPlan.uuid);
    if (this.isCameraPlanEnabled) {
      plans.push(this.cameraPlan.uuid);
    }
    const formData = {
      plan_id: plans,
      amount:  this.getTotalPrice(),
      paymentToken: this.formData.paymentToken,
      registerToken: this.formData.registerToken
    };
    this.isSubmitted = true;
    this.paymentService.buySubscription({
      Authorization: this.accessToken,
      body: this.helperService.updateJsonFormat(formData)
    }).subscribe(response => {
      this.authService.setSubscribed(1);
      this.authService.setSubscriptionStatus('active');
      this.paymentSuccessMessage = 'Thankyou for your subscription at betaspace. Your account is now activated.';
      this.isSubmitted = false;
    }, err => {
      if (err && err.error && err.error.errors && err.error.errors[0]) {
        this.errors = err.error.errors;
      } else {
        this.paymentErrorMessage = 'There was error while paying for your subscription.';
      }
      this.isSubmitted = false;
    });
  }

  getTotalPrice() {
    return this.getSubTotalPrice() + this.getTaxAmount();
  }

  getSubTotalPrice() {
    if (this.isCameraPlanEnabled) {
      return this.subscriptionPlan.new_price + this.cameraPlan.new_price;
    }
    return this.subscriptionPlan.new_price;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }
}
